import { Pipe, PipeTransform } from '@angular/core';
import { LocalStorageService } from '../../core/local-storage.service';

interface LanguageData {
    value: string,
    key: string;
}
@Pipe({ name: 'languageTranslation' })
export class LanguageTranslatePipe implements PipeTransform {
    data: Array<LanguageData> = [];
    constructor(localStorageService: LocalStorageService) {
        this.data = localStorageService.getSelectedLanguageData();
    }
    transform(value: any): string {
        const index = this.data.findIndex(res => res.key ==value);
        if(index >= 0) {
            return this.data[index].value
        }
        // for (const property in this.data) {
        //     if (property === value) {
        //         return this.data[property];
        //     }
        // }
    }
}